import {
    FETCH_UPDATE_USER_REQUEST,
    FETCH_UPDATE_USER_SUCCESS,
    FETCH_UPDATE_USER_FAILURE,
    SET_UPDATE_USER
} from '../../actions/users/update-users-actions';

const initialState = {
    updatedUser: null,
    user: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const UpdateUserReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_UPDATE_USER_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case SET_UPDATE_USER:
            return {
                ...state,
                isLoading: false,
                error: null,
                user: { ...action.payload }
            };
        case FETCH_UPDATE_USER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                updatedUser: action.payload[0],
            };
        case FETCH_UPDATE_USER_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default UpdateUserReducer;